import type { Theme } from '@mui/material/styles';

export function getPortalBranding(theme: Theme, fallbackTitle: string) {
  return {
    clientName: theme.clientName?.trim() || 'Atlas',
    portalTitle: theme.portalTitle?.trim() || fallbackTitle,
  };
}
